import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../ReduxStore/userReducer";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const environment = process.env.REACT_APP_ENVIRONMENT;

const apiClient = axios.create({
    baseURL: apiBaseUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

const useApiClient = () => {
    const [isTokenSet, setIsTokenSet] = useState(false);

    useEffect(() => {
        const userData = localStorage.getItem('userData');
        // const parsedUserData = userData ? JSON.parse(userData) : null;
        const parsedUserData = userData ? userData.JwtToken : null;
// console.log("parsedUserData :", parsedUserData);

        if (parsedUserData) {
            apiClient.defaults.headers['wg_token'] = parsedUserData;
            setIsTokenSet(true);
        }
    }, []);

    return { isTokenSet };
};

const ApiComponent = () => {
    const { isTokenSet } = useApiClient();

    useEffect(() => {
        if (isTokenSet) {
            // console.log("Token has beeb set successfully");
        }
    }, [isTokenSet]);

    return <div>ApiComponent</div>
}

apiClient.interceptors.request.use(
    (config) => {
        const userString = localStorage.getItem('userData');
        const userData = JSON.parse(userString);
        
        const parsedUserData = userData ? userData.JwtToken : null;
        // const parsedUserData = userData ? JSON.parse(userData) : null;
        // console.log("parsedUserData.request :", parsedUserData);
        if (parsedUserData) {
            config.headers['wg_token'] = parsedUserData;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            const { status, data } = error.response;

            switch (status) {
                case 401:
                    console.log('Unauthorized access. Token expried or missing.');
                    break;
                default:
                    console.error('An error occured:', data?.message);
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;
export { useApiClient, ApiComponent };